export default class Forms {

  constructor() {
    this.setupForms();

    this.scrollOffset = 0;

    console.log('FORM CONTROLLER');
  }

  setupForms() {

    $('.form-formItem textarea').focus( (e) => {

      if ( $(e.currentTarget).val() === $(e.currentTarget).data('default') ) {
        $(e.currentTarget).val('');
      }
    });

    $('.form-formItem textarea').blur( (e) => {

      if ( $(e.currentTarget).val() === '' ) {
        $(e.currentTarget).val( `${$(e.currentTarget).data('default')}` );
        $(e.currentTarget).parent().removeClass('has-content');
      } else {
        $(e.currentTarget).parent().addClass('has-content');
        $(e.currentTarget).parent().removeClass('has-error');
      }
    });


    $('.form-formItem input[type="text"],.form-formItem input[type="email"],.form-formItem select').focus( (e) => {

      if ( !$(e.currentTarget).parent().hasClass('form-ignoreAni') ) {
        $(e.currentTarget).parent().addClass('is-focused');
      }
    });

    $('.form-formItem input[type="text"],.form-formItem input[type="email"],.form-formItem select').blur( (e) => {
      let valid = true;


      if ( $(e.currentTarget).val() !== '' ) {

        // start validating form types
        if ( $(e.currentTarget).parent().hasClass('form-formEmail') ) {
          valid = this.validateEmail( $(e.currentTarget).val() );
        }

        if ( $(e.currentTarget).parent().hasClass('form-formPhone') ) {
          valid = this.validatePhone( $(e.currentTarget).val() );
        }
        // end validating form types

        if ( !valid ) {
          if ( !$(e.currentTarget).parent().hasClass('form-ignoreAni') ) {
            $(e.currentTarget).parent().addClass('has-error');
            $(e.currentTarget).parent().addClass('has-content');
          }
        } else {
          if ( !$(e.currentTarget).parent().hasClass('form-ignoreAni') ) {
            $(e.currentTarget).parent().addClass('has-content');
          }
          $(e.currentTarget).parent().removeClass('has-error');
        }

      } else {
        $(e.currentTarget).parent().removeClass('has-content');
        $(e.currentTarget).parent().removeClass('has-error');
      }

      console.log($(e.currentTarget).parent().hasClass('form-ignoreAni'));

      if ( !$(e.currentTarget).parent().hasClass('form-ignoreAni') ) {
        console.log('REMOVE CLASS', $(e.currentTarget).parent());
        $(e.currentTarget).parent().removeClass('is-focused');
      }

    });
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone) {
    const re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return re.test(phone);
  }

}



// WEBPACK FOOTER //
// ./js/modules/Forms.js